namespace $.$$ {
	
	const { rem } = $mol_style_unit

	$mol_style_define( $mol_text_code_row, {

		display: 'block',
		
		Numb: {
			textAlign: 'right',
			color: $mol_theme.shade,
			width: rem(3),
			padding: {
				right: rem(1.5),
			},
			margin: {
				left: rem(-3),
			},
			display: 'inline-block',
			whiteSpace: 'nowrap',
			userSelect: 'none',
		},

	} )
	
}
